import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { reviewSessionApi } from "./reviewSession.api";
import { ReviewSession } from "./reviewSession.schema";

export interface ReviewSessionState {
	current: ReviewSession | null;
}

const initialState: ReviewSessionState = {
	current: null,
};

export const reviewSessionSlice = createSlice({
	name: "reviewSession",
	initialState,
	reducers: {
		clearReviewSession(state) {
			state.current = null;
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(
			reviewSessionApi.endpoints.createReviewSession.matchFulfilled,
			(state, { payload }: PayloadAction<ReviewSession>) => {
				state.current = payload;
			}
		);

		builder.addMatcher(
			reviewSessionApi.endpoints.getReviewSession.matchFulfilled,
			(state, { payload }: PayloadAction<ReviewSession>) => {
				state.current = payload;
			}
		);
	},
});

export const { clearReviewSession } = reviewSessionSlice.actions;
export const reviewSessionReducer = reviewSessionSlice.reducer;
export const reviewSessionSelector = (state: RootState) => state[reviewSessionSlice.name];
